/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobUpdatePriorityRequest {
    getFixupPrototypeFunction() { return BackgroundJobUpdatePriorityRequest.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobUpdatePriorityRequest>): BackgroundJobUpdatePriorityRequest {
        let obj = Object.assign(new BackgroundJobUpdatePriorityRequest(), model);
        BackgroundJobUpdatePriorityRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobUpdatePriorityRequest>): BackgroundJobUpdatePriorityRequest {
        if (!model) return null;
        return BackgroundJobUpdatePriorityRequest.newInstance(<BackgroundJobUpdatePriorityRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobUpdatePriorityRequest) {
        if (!obj) return;

        models.BackgroundJobUpdatePriorityRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobUpdatePriorityRequest): boolean {
        Object.setPrototypeOf(obj, BackgroundJobUpdatePriorityRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.job) {
            models.RecordIdentity.fixupPrototype(this.job);
        }
    }

    /**
     * Background Job to update
     */
    job: models.RecordIdentity;

    /**
     * New priority of the Background Job
     */
    priority: number;

}
